import { useEffect, useState } from "react";

const KEY = "pechespot_favorites";
const EVT = "favorites-changed";

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

export const useFavorites = () => {
  const [favs, setFavs] = useState(read);

  useEffect(() => {
    const sync = () => setFavs(read());
    window.addEventListener(EVT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const toggle = (id) => {
    const cur = read();
    const next = cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id];
    localStorage.setItem(KEY, JSON.stringify(next));
    window.dispatchEvent(new Event(EVT));
    return next.includes(id);
  };

  return { favs, isFav: (id) => favs.includes(id), toggle };
};
